import { create } from 'zustand';

import { Modal, ModalProps } from '../ui/Modal';
import { Drawer, DrawerProps } from '../ui/Drawer';

type ModalConfig = Omit<ModalProps, 'open' | 'onClose'>;
type DrawerConfig = Omit<DrawerProps, 'open' | 'onClose'>;

interface ModalState {
  modals: { id: string; config: ModalConfig }[];
  drawers: { id: string; config: DrawerConfig }[];
  openModal: (id: string, config: ModalConfig) => void;
  closeModal: (id: string) => void;
  openDrawer: (id: string, config: DrawerConfig) => void;
  closeDrawer: (id: string) => void;
  closeAll: () => void;
}

// eslint-disable-next-line react-refresh/only-export-components
export const useModalStore = create<ModalState>((set) => ({
  modals: [],
  drawers: [],
  openModal: (id, config) => set((state) => ({ modals: [...state.modals, { id, config }] })),
  closeModal: (id) => set((state) => ({ modals: state.modals.filter((m) => m.id !== id) })),
  openDrawer: (id, config) => set((state) => ({ drawers: [...state.drawers, { id, config }] })),
  closeDrawer: (id) => set((state) => ({ drawers: state.drawers.filter((d) => d.id !== id) })),
  closeAll: () => set({ modals: [], drawers: [] }),
}));

export function OverlayManager() {
  const { modals, drawers, closeModal, closeDrawer } = useModalStore();

  return (
    <div data-shell-plane="overlay">
      {drawers.map(({ id, config }) => (
        <Drawer key={id} open={true} onClose={() => closeDrawer(id)} {...config} />
      ))}
      {modals.map(({ id, config }) => (
        <Modal key={id} open={true} onClose={() => closeModal(id)} {...config} />
      ))}
    </div>
  );
}
